import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';

const COLORS = ['#93C5FD', '#3B82F6', '#1D4ED8'];

const tooltipStyle = {
    backgroundColor: '#1e293b',
    border: '1px solid #334155',
    borderRadius: 6,
    color: '#e2e8f0',
    fontSize: 12,
};

export default function SurveyStatsCard({ data }) {
    const chartData = [
        { name: 'Created', value: data.undeployed },
        { name: 'Deployed', value: data.deployed },
        { name: 'Executed', value: data.executed },
    ];

    const total = data.undeployed + data.deployed + data.executed;

    return (
        <div style={styles.card}>
            <h3 style={styles.title}>Surveys</h3>
            <div style={styles.chartContainer}>
                <ResponsiveContainer width="100%" height={200}>
                    <PieChart>
                        <Pie
                            data={chartData}
                            cx="50%"
                            cy="50%"
                            innerRadius={55}
                            outerRadius={80}
                            dataKey="value"
                            stroke="none"
                        >
                            {chartData.map((entry, i) => (
                                <Cell key={entry.name} fill={COLORS[i]} />
                            ))}
                        </Pie>
                        <Tooltip contentStyle={tooltipStyle} />
                    </PieChart>
                </ResponsiveContainer>
                <div style={styles.centerLabel}>
                    <span style={styles.totalNumber}>{total}</span>
                    <span style={styles.totalLabel}>Total</span>
                </div>
            </div>
            <div style={styles.legend}>
                {chartData.map((entry, i) => (
                    <div key={entry.name} style={styles.legendItem}>
                        <span style={{ ...styles.legendDot, backgroundColor: COLORS[i] }} />
                        <span style={styles.legendText}>{entry.name}</span>
                        <span style={{ ...styles.legendCount, color: COLORS[i] }}>{entry.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}

const styles = {
    card: {
        background: '#1e3a5f',
        border: '1px solid #2d4a6f',
        borderRadius: 8,
        padding: 20,
    },
    title: {
        margin: 0,
        marginBottom: 4,
        fontSize: 14,
        fontWeight: 600,
        color: '#FFFFFF',
    },
    chartContainer: {
        position: 'relative',
    },
    centerLabel: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pointerEvents: 'none',
    },
    totalNumber: {
        fontSize: 28,
        fontWeight: 700,
        color: '#FFFFFF',
    },
    totalLabel: {
        fontSize: 11,
        color: '#94A3B8',
    },
    legend: {
        display: 'flex',
        justifyContent: 'center',
        gap: 20,
        marginTop: 4,
    },
    legendItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
    },
    legendDot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
        display: 'inline-block',
    },
    legendText: {
        fontSize: 12,
        color: '#CBD5E1',
    },
    legendCount: {
        fontSize: 14,
        fontWeight: 700,
    },
};
